import { useEffect, useState } from "react";
import { BiSolidMicrophone, BiSolidPhone } from "react-icons/bi";
import { AnimatePresence, motion } from "framer-motion";
import { formatPhoneNumber } from "../../utils/stringUtils";

const ICON_MAP = {
    RINGING: <BiSolidPhone color="white" size={16} />,
    START_CALL: <BiSolidMicrophone color="white" size={16} />,
};

const formatElapsed = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
};

const SystemMessage = ({ action, message }) => {
    const [countdown, setCountdown] = useState(3);
    const [elapsed, setElapsed] = useState(0);
    const icon = ICON_MAP[action];

    useEffect(() => {
        if (action !== "RINGING") return;
        setCountdown(3);
        const interval = setInterval(() => {
            setCountdown((prev) => (prev > 1 ? prev - 1 : 1));
        }, 1000);
        return () => clearInterval(interval);
    }, [action, message]);

    useEffect(() => {
        if (action !== "START_CALL") return;
        setElapsed(0);
        const interval = setInterval(() => {
            setElapsed((prev) => prev + 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [action, message]);

    return (
        <AnimatePresence>
            {message && (
                <motion.div
                    initial={{ y: 40, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 40, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 260, damping: 20 }}
                    style={{
                        position: 'fixed',
                        bottom: 'calc((100dvh - 800px) / 2 + 48px)',
                        left: 0,
                        right: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        zIndex: 9999,
                        pointerEvents: 'none',
                    }}
                >
                    <div
                        style={{
                            padding: '10px 16px',
                            background: '#797979DD',
                            backdropFilter: 'blur(4px)',
                            borderRadius: '24px',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: '6px',
                            boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
                        }}
                    >
                        {icon}

                        <span
                            style={{
                                whiteSpace: 'nowrap',
                                color: 'white',
                                fontSize: '14px',
                                fontFamily: 'Pretendard',
                                fontWeight: 500,
                            }}
                        >
                            {action === "START_CALL"
                                ? `띠링이 응대 중이에요 ${formatElapsed(elapsed)}`
                                : `${formatPhoneNumber(message)}님이 전화하셨어요${action === "RINGING" ? `...${countdown}` : ""}`
                            }
                        </span>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default SystemMessage;
